import type { ScraperDiagnosticsResponse } from "../../types/scraperDiagnostics";

export interface AnalysisRange {
  since: string;
  until: string;
}
export function recentRange(days: number, now = new Date()): AnalysisRange {
  return {
    since: new Date(now.getTime() - days * 86400000).toISOString(),
    until: now.toISOString(),
  };
}
export function rangeError(range: Partial<AnalysisRange>, now = Date.now()): string | null {
  const since = Date.parse(range.since ?? "");
  const until = Date.parse(range.until ?? "");
  if (!Number.isFinite(since) || !Number.isFinite(until)) return "Wybierz obie daty.";
  if (since >= until) return "Początek musi być wcześniejszy niż koniec.";
  if (until > now) return "Zakres nie może wybiegać w przyszłość.";
  if (until - since > 30 * 86400000) return "Maksymalny zakres to 30 dni.";
  return null;
}

export function filterDiagnostics(
  data: ScraperDiagnosticsResponse,
  source: string,
): ScraperDiagnosticsResponse {
  if (!source) return data;
  const sources = data.health.sources.filter((row) => row.source_name === source);
  const keys = new Set(sources.map((row) => row.source));
  const summary = { ok: 0, warn: 0, crit: 0, unknown: 0 };
  const totals = {
    runs: 0,
    created: 0,
    revised: 0,
    upserts_failed: 0,
    requests_total: 0,
  };
  for (const row of sources) {
    summary[row.health]++;
    for (const key of Object.keys(totals) as (keyof typeof totals)[]) totals[key] += row[key];
  }
  const rows = data.reconciliation.rows.filter((row) => row.source_name === source);
  return {
    ...data,
    health: {
      ...data.health,
      sources,
      summary,
      totals,
      has_telemetry: sources.some((row) => row.runs > 0),
    },
    reconciliation: {
      ...data.reconciliation,
      rows,
      drifting_sources: rows.filter((row) => row.status === "rozjazd").length,
    },
    timeline: {
      ...data.timeline,
      runs: data.timeline.runs.filter((row) => row.source === source || keys.has(row.source)),
    },
    yield_trend: {
      ...data.yield_trend,
      points: data.yield_trend.points.filter(
        (row) => row.source === source || keys.has(row.source),
      ),
    },
  };
}

/** Global denominator must come from the unfiltered response for the same window. */
export function newTenderShare(created: number, allNew: number | null): number | null {
  if (allNew === null) return null;
  return allNew > 0 ? (created / allNew) * 100 : 0;
}
